import { BfLog4js, BfLogConsoleAppender, BfLogLevel } from '@tw/tw-log4js';
BfLog4js.configure({
  level: BfLogLevel.DEBUG,
  appenderFactory: () => {
    return [new BfLogConsoleAppender()];
  }
});
